// extracted by mini-css-extract-plugin
module.exports = {"sectionsBackground":"Tutorials-module--sectionsBackground--1QUAQ","sectionHeader":"Tutorials-module--sectionHeader--540Ri","sectionIcon":"Tutorials-module--sectionIcon--2rwwe"};